import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { FC, useRef } from 'react';

interface Props {
  studentList: { firstName: string; lastName: string }[];
  /** Defaults to the short label the meter-group call sites use. */
  label?: string;
  /** Analytics id. Defaults to the one the meter-group call sites have always reported under. */
  id?: string;
}

const CopyListOfStudentsButton: FC<Props> = ({ studentList, label = 'Copy list', id = 'SkillPassedCopyButton' }) => {
  const toast = useRef<Toast>(null);
  const handleCopy = async () => {
    try {
      const namesToString: string | undefined = studentList
        ?.map(student => student.firstName + ' ' + student.lastName)
        ?.join(', ');
      if (namesToString) {
        await navigator.clipboard.writeText(namesToString);
        toast.current?.show({
          severity: 'success',
          summary: 'Success',
          detail: 'Student(s) have been copied to clipboard!',
          life: 3000,
        });
      }
    } catch (_error) {
      toast.current?.show({
        severity: 'error',
        summary: 'Error',
        detail: 'Student(s) have not been copied to clipboard',
        life: 3000,
      });
    }
  };
  return (
    <>
      <Button
        id={id}
        icon="nc_icon-nc_copy icon-sm"
        label={label}
        onClick={handleCopy}
        className="nc_metergroup-button"
      ></Button>
      <Toast ref={toast} position="top-right" appendTo={document.body} />
    </>
  );
};

export default CopyListOfStudentsButton;
